<template>
  <div class="country-card card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <ui-icon @click="emit('close')" icon="fas fa-times" size="12" class="card-condition__close" />
    <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" :label="title">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>
    <div class="connection-type__chech-group mb-16">
      <ui-checkbox :label="t('Include empty value')" v-model="includeUnknown" />
    </div>
    <div>
      <ui-textarea v-model="textAreaValue" :hide-details="2" />
    </div>
    <div class="custom-card__bottomtext">
      <p>{{ t('Please enter one custom parameter value per line') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import { useFlowCustomCondition } from './useFlowCustomCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string[] }>;
  title: string;
  name: string;
  getItem?: unknown[];
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const { predicate, includeUnknown, textAreaValue } = useFlowCustomCondition(
  props.conditions,
  props.name,
);
</script>

<style lang="scss"></style>
